import naja from 'naja';

class AjaxOverlay {
	#naja;

	constructor() {
		this.#naja = naja;
	}

	init() {
		this.#addEventListeners();
	}

	#addEventListeners() {
		this.#naja.addEventListener('before', (event) => {
			if (event.detail.data) {
				const ajaxOverlay = event.detail.data.ajaxOverlay;

				if (ajaxOverlay) {
					this.#ajaxOverlayHandler(ajaxOverlay);
				}
			}
		});

		this.#naja.uiHandler.addEventListener('interaction', (event) => {
			const form = event.detail.element.form;
			if (form && !form.checkValidity()) {
				event.preventDefault();
				return;
			}
			const ajaxOverlay = event.detail.element.getAttribute('data-ajax-overlay') ?? form?.getAttribute('data-ajax-overlay');

			if (ajaxOverlay) {
				this.#ajaxOverlayHandler(ajaxOverlay);
			}
		});

		this.#naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			const snippet = document.getElementById(event.detail.snippet.id);
			snippet.style.opacity = '1';

			const spinnerContainer = snippet.querySelector('.spinner-container');
			if(spinnerContainer) {
				spinnerContainer.remove();
			}

/*
			if ('removeNajaSnippetAppend' in snippet.dataset) {
				delete snippet.dataset.removeNajaSnippetAppend;
				delete snippet.dataset.najaSnippetAppend
			}
*/
		});

	}

	#ajaxOverlayHandler(ajaxOverlay) {
		const overlays = ajaxOverlay.split(',')
		overlays.forEach(function (overlay) {
			const snippet = document.getElementById('snippet--' + overlay) ?? document.getElementById('snippet-' + overlay);
			if (snippet) {
				snippet.classList.add('ajax-overlay');
				const snippetBoundingClientRect = snippet.getBoundingClientRect();
				const snippetWidth = snippetBoundingClientRect.width;
				const snippetHeight = snippetBoundingClientRect.height;
				/*
								let snippetTop = snippetBoundingClientRect.top;
								let snippetLeft = snippetBoundingClientRect.left;
				*/
				let spinnerContainer = document.createElement('div');
				spinnerContainer.classList.add('spinner-container');
				spinnerContainer.style.position = 'absolute';
				spinnerContainer.style.width = snippetWidth + 'px';
				spinnerContainer.style.height = snippetHeight + 'px';
				spinnerContainer.style.display = 'flex';
				spinnerContainer.style.justifyContent = 'center';

				let spinnerSize = 100;
				if (snippetWidth > 0 && snippetHeight > 0 && (snippetWidth < 100 || snippetHeight < 100)) {
					spinnerSize = Math.min(snippetWidth, snippetHeight);
				}
				spinnerSize = spinnerSize * 0.7; //aby se úhlopříčka čtverce spinneru vešla i nastojato

				snippet.style.transition = 'opacity 0.25s';
				snippet.style.opacity = '0.5';

				const spinner = document.createElement('div');
				spinner.setAttribute('class', 'spinner');
				spinner.innerHTML = '<div class="dot1"></div><div class="dot2"></div>';
				spinnerContainer.append(spinner)
				snippet.prepend(spinnerContainer);
				/*
								if (spinner.style.position === 'relative') {
									spinner.style.top = '100px';
									spinner.style.left = ((snippetWidth) / 2) - (spinnerSize / 2) + 'px';
								}
								else {
									spinner.style.top = snippetTop + 100 + 'px';
									spinner.style.left = ((snippetWidth) / 2) + snippetLeft - (spinnerSize / 2) + 'px';
								}
				*/
				spinner.style.visibility = 'visible';
				spinner.style.width = spinnerSize + 'px';
				spinner.style.height = spinnerSize + 'px';
				spinner.style.zIndex = '9999';
			}
		});
	}
}

export default new AjaxOverlay();